import { useCallback, useEffect, useMemo, useState } from 'react';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';

export default function useFeatureFlag(featureName: string) {
  const userLoading = useAuthStore((state) => state.isLoading);
  const user = useAuthStore((state) => state.user);
  const [isFeatureEnabled, setIsFeatureEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Start as true, assume loading initially

  const featureFlags = useMemo(() => {
    return user?.featureFlags;
  }, [user?.featureFlags]);

  const checkIfUserEnabled = useCallback(async () => {
    // Return a promise that resolves to a boolean
    return new Promise<boolean>((resolve) => {
      if (!userLoading) {
        // Ensure auth check is completed
        if (featureFlags?.includes(featureName)) {
          resolve(true); // Feature is enabled for the user
        } else {
          resolve(false); // Feature is not enabled for the user
        }
      }
    });
  }, [featureName, featureFlags, userLoading]);

  useEffect(() => {
    setIsLoading(true); // Ensure loading is true when starting the check
    checkIfUserEnabled().then((isEnabled) => {
      setIsFeatureEnabled(isEnabled); // Set based on the resolved promise value
      setIsLoading(false); // Loading is complete after setting the feature flag state
    });
  }, [checkIfUserEnabled]);

  return { isFeatureEnabled, isLoading };
}
